<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

const goBack = () => {
  router.push('/guests');
};
</script>

<template>
  <div class="mobile-table-planner">
    <div class="mobile-table-planner__content">
      <i class="pi pi-desktop mobile-table-planner__icon"></i>
      <h2 class="mobile-table-planner__title">Planer stołów dostępny tylko na komputerze</h2>
      <p class="mobile-table-planner__message">
        Planowanie układu stołów wymaga większego ekranu i precyzyjnej kontroli myszą. Prosimy o korzystanie z wersji
        desktopowej.
      </p>
      <button
        class="mobile-table-planner__button"
        @click="goBack"
      >
        <i class="pi pi-arrow-left"></i>
        Powrót do listy gości
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mobile-table-planner {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 1rem;
  background-color: #f8f8f8;

  &__content {
    max-width: 400px;
    text-align: center;
    padding: 2rem;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgb(0 0 0 / 10%);
  }

  &__icon {
    font-size: 4rem;
    color: #834920;
    margin-bottom: 1.5rem;
  }

  &__title {
    font-size: 2rem;
    color: #333;
    margin-bottom: 1.5rem;
    font-weight: 600;
  }

  &__message {
    color: #666;
    margin-bottom: 2.5rem;
    line-height: 1.5;
    font-size: 1.5rem;
  }

  &__button {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 2rem;
    background-color: #834920;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1.5rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 100%;
    justify-content: center;

    &:hover {
      background-color: #6b3a1a;
    }

    i {
      font-size: 1.5rem;
    }
  }
}
</style>
